import { Component, OnInit } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { ApiService } from "../../services/api.service";
import { TimerService } from "../../services/timer.service";
import { WalletService } from "../../services/wallet.service";
import { WalletConnectDialogComponent } from "../../wallet-connect-dialog/wallet-connect-dialog.component";
import { Tabs } from "../tabs";
@Component({
    selector: "ngx-recent-transactions",
    templateUrl: "./recent-transactions.component.html",
    styleUrls: ["./recent-transactions.component.scss"],
})
export class RecentTransactionsComponent implements OnInit {
    tabs = Tabs;
    isConnected = false;
    private currentUserAddres = "";
    timeEnd;
    constructor(
        // private _walletService : WalletService,
        public _timerService: TimerService,
        public _walletService: WalletService,
        public _apiService: ApiService,
        public nbDialogService: NbDialogService
    ) {}
    openDialog() {
        this.nbDialogService.open(WalletConnectDialogComponent, {
            context: {},
        });
    }
    ngOnInit() {
        // this._timerService.getTime();
        this.checkwallet();
        this._walletService.checkWalletDisconnect();
    }

    connectWallet = async () => {
        this.currentUserAddres = await this._walletService.initConnection();
        // this._apiService.insertWhitelistedAddress(this.currentUserAddres).subscribe();
    };

    checkwallet = async () => {
        if (await this._walletService.checkWalletConnection()) {
            this.isConnected = false;
        } else {
            this.isConnected = true;
        }
    };
}
